<template>
  <li class="order-ys-item-wrapper">
    <div class="order-title">
      <div class="seller-info">
        <img
          src="../../../assets/images/order/icon-ys-item-order.png"
          class="icon-ys-order"
        />
        <div class="seller-name pf-medium">月嫂订单</div>
      </div>
      <div class="order-status order-status-lighted">
        {{ orderSynthesisStateDesc }}
      </div>
    </div>
    <div class="order-info">
      <div class="ctn">
        <Avatar :url="order.headImage" @click="gotoUserDetail(order)" />
        <div class="des" @click="gotoOrderDetail(order)">
          <div>
            <div class="ys-name pf-medium">
              {{ !isVirtual ? order.workerName : '孩子王月嫂' }}
            </div>
            <p>规格：{{ newSkuName }}</p>
          </div>
          <p class="pay-time">下单时间：{{ ORDER_TIME }}</p>
        </div>
        <div class="right-p">
          <span class="s-price pf-simbold"
            >&yen;{{ (order.orderPrice / order.num) | priceNum }}</span
          >
          <span class="number">x{{ order.num }}</span>
        </div>
      </div>
      <div class="order-total-pay">
        <p>
          <span v-if="!prePayOrder">总价：&yen;{{ totalOrderPrice }}，</span>
          <span v-if="!prePayOrder && orderDistcountPrice"
            >优惠：&yen;{{ orderDistcountPrice }}，</span
          >

          <span
            class="real-pay"
            v-if="prePayOrder && prePayOrder.preOrderState == 10"
            >待付定金：<span class="total-y pf-medium"
              >&yen;{{ prePayOrder.prePayPrice | priceNum }}</span
            >
          </span>

          <span
            class="real-pay"
            v-else-if="endPayOrder && endPayOrder.endOrderState == 10"
            >已付定金：&yen;{{ prePayOrder.prePayPrice | priceNum }}，待付尾款：
            <span class="total-y pf-medium"
              >&yen;{{ endPayOrder.endPayPrice | priceNum }}</span
            >
          </span>
          <!--  待支付 - 应付款，其他都是 - 实付款 -->
          <span v-else class="real-pay"
            >{{ order.orderState == 10 ? '应付款' : '实付款' }}：<span
              class="total-y pf-medium"
              >&yen;{{ totalPayMoney }}</span
            >
          </span>
        </p>
      </div>
      <ItemButton
        :index="index"
        :order="order"
        :OpenDel="true"
        :cancelOrder="cancelOrder"
      />
    </div>
    <actionSheet
      v-if="isShow"
      :viewName="viewName"
      :params="params"
      :callback="closeActionSheet"
    ></actionSheet>
  </li>
</template>
<script>
import ItemButton from './button.vue'
import Avatar from '../../avatar'
import utils from '@/plugins/utils'
import {
  B_ORDER_YS,
  isNewAsignedMonthInLaw,
  getOrderSynthesisStateDesc
} from '@/business'
import order from '@/store/actions/order'
import { mapState, mapMutations } from 'vuex'
import actionSheet from '@/components/actionSheet/index.vue'
import log from '@/store/actions/log'

export default {
  inject: ['reload'],
  props: {
    order: { type: Object },
    index: { type: [String, Number] },
    totalPayMoney: { type: [String, Number] },
    gotoUserDetail: { type: Function },
    gotoOrderDetail: { type: Function },
    prePayOrder: { type: Object },
    endPayOrder: { type: Object }
  },
  components: {
    ItemButton,
    Avatar,
    actionSheet
  },
  data() {
    return {
      params: {},
      isShow: false
    }
  },
  computed: {
    ...mapState(['viewName']),
    orderSynthesisStateDesc() {
      return getOrderSynthesisStateDesc(this.order)
    },
    isVirtual() {
      const { workerType = 1 } = this.order
      return B_ORDER_YS.isVirtual(workerType)
    },
    ORDER_TIME() {
      return utils.dateFormat(this.order.orderTime, 'YY-MM-DD hh:mm:ss')
    },
    newSkuName() {
      let str = this.order.skuName.replace('签约', '').replace('嫂', '嫂 ')
      let reg = str.match(/\S星/)
      if (reg) {
        const index = reg.index
        if (index) {
          let arr = str.split('')
          let s = '市'
          let y = arr.indexOf(s)

          arr.splice(index, 0, y === -1 ? s + ' ' : ' ')
          str = arr.join('')
        }
      }
      return str
    },
    totalOrderPrice() {
      return this.order.orderPrice / 100
    },
    orderDistcountPrice() {
      return this.order.discountPrice / 100
    }
  },
  methods: {
    ...mapMutations(['showActionSheet', 'setActionHeader', 'changeView']),
    cancelOrder() {
      this.isShow = true

      this.changeView('cancelReasonUseInList')
      this.setActionHeader({
        title: '取消原因'
      })
      console.log(this.order)
      this.params = {
        order: this.order,
        success: () => {
          this.reload()
          this.isShow = false
        }
      }
      this.showActionSheet()
    },
    closeActionSheet() {
      this.isShow = false
    }
  }
}
</script>
<style lang="scss" scoped src="../orderListItemStyle.scss" />
<style lang="scss" scoped src="./style.scss" />
